import { useFocusRef } from 'hooks/useFocusRef';
import { ChangeEvent, FC, KeyboardEvent, useCallback, useState } from 'react';

type EditableTextCellProps = {
  id: string;
  e2e: string;
  value: string;
  tabIndex?: number;

  onBlur: (v: string) => void;
  onKeyDown: (e: KeyboardEvent) => void;
  onPaste?: (e: ClipboardEvent) => void;
};

export const EditableTextCell: FC<EditableTextCellProps> = ({ id, e2e, value, tabIndex, onKeyDown, onBlur }) => {
  const inputRef = useFocusRef(true);
  const [editedValue, setEditedValue] = useState<string>(value);

  const onChangeEvent = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setEditedValue(e.target.value);
  }, []);

  const onBlurEvent = useCallback(
    (_: ChangeEvent<HTMLInputElement>) => {
      onBlur(editedValue);
    },
    [editedValue, onBlur],
  );

  return (
    <input
      ref={inputRef}
      id={id}
      data-e2e={e2e}
      type="text"
      className="form-control clickable"
      onKeyDown={onKeyDown}
      onChange={onChangeEvent}
      onBlur={onBlurEvent}
      value={editedValue}
      tabIndex={tabIndex}
    />
  );
};
